import * as core from '../../../../../../../core'

import { query } from './subrecipients-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subrecipients.widgets.subrecipients-table',
    description: 'Subrecipients',
    name: 'Subrecipients',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
